
import Vue, { PropType } from 'vue'
import { MapLocationInterface } from '@/types/models'

export default Vue.extend({
  props: {
    value: Object as PropType<MapLocationInterface>,
    parent: {
      type: Object as PropType<MapLocationInterface>,
      default: (): MapLocationInterface => ({
        shape: 'rect',
        x: 0,
        y: 0,
        bin: 'unknown',
        width: 0,
      }),
    },
    tooltip: String,
  },
  computed: {
    parentX(): number {
      return this.parent.x || 0
      // return ['circle', 'ellipse'].includes(this.parent.shape)
      //   ? this.parent.cx - (this.parent.shape === 'ellipse' ? this.parent.rx : this.parent.r)
      //   : this.parent.x
    },
    parentY(): number {
      return this.parent.y || 0
      // return ['circle', 'ellipse'].includes(this.parent.shape)
      //   ? this.parent.cy - (this.parent.shape === 'ellipse' ? this.parent.ry : this.parent.r)
      //   : this.parent.y
    },
  },
  methods: {
    click(): void {
      this.$emit('click')
    },
  },
})
